export default "__VITE_ASSET__Ca0yc6me__"